const NOTE_HTML_MAX_LENGTH = 1000000 as const;

export default NOTE_HTML_MAX_LENGTH;
